import type { CSSObject } from 'tss-react';
import { Theme, lighten } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

interface StyleProps {
  badgeColour?: string;
}

export const useBadgeColour = makeStyles<StyleProps>()((_, props) => ({
  badge: {
    backgroundColor: props.badgeColour ?? 'transparent',
  },
}));

export const useStyles = makeStyles()(({ breakpoints, typography, spacing }: Theme) => ({
  listItemIcon: {
    justifyContent: 'center',
    minWidth: 0,
    padding: spacing(0, 2),
    [breakpoints.up('lg')]: {
      justifyContent: 'normal',
    },
  },
  listItemTextWrapper: {
    margin: 0,
  },
  listItemText: {
    padding: spacing(0, 1),
    [breakpoints.between('sm', 'lg')]: {
      padding: spacing(0, 0.5),
      textAlign: 'center',
      ...(typography.subtitle1 as CSSObject),
    },
  },
  secondaryAction: {
    right: spacing(3),
  },
}));

export const useListItem = makeStyles()(({ breakpoints, palette, spacing }: Theme) => ({
  root: {
    borderRadius: spacing(1),
    backgroundColor: palette.primary.dark,
    color: palette.secondary.lightest,
    padding: spacing(1.5, 1),

    justifyContent: 'center',
    flexDirection: 'row',
    [breakpoints.between('sm', 'lg')]: {
      flexDirection: 'column',
      padding: spacing(2, 0.5, 1, 0.5),
    },
    '&:hover': {
      backgroundColor: lighten(palette.primary.dark, palette.action.hoverOpacity),
    },

    '&.Mui-selected, &.Mui-selected:hover': {
      backgroundColor: 'rgba(238, 242, 245, 0.15)',
      color: palette.common.white,
    },
  },
  selected: {},
}));
